module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-1330.59a24336.jpg";